export default "__VITE_ASSET__vnCiEXm9__"